module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_7042.365fb2e7.png";